module.exports = "<mat-progress-spinner [color]=\"'primary'\" [mode]=\"'indeterminate'\" *ngIf=\"isLoading\"></mat-progress-spinner>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/with-loader/with-loader.component.html
// module id = ../../../../../src/app/directive/with-loader/with-loader.component.html
// module chunks = main